import { useEffect } from 'react'
import { AssetTransferStatus, useTransferOrderQuery } from '../../../graphql'

type UseAssetTransferPollingParams = {
	transferOrderId: string,
	assetTransferStatus: AssetTransferStatus | null | undefined,
}

const POLL_INTERVAL_MS = 5000

/**
 * Polls the TransferOrder query every 5 seconds while assetTransferStatus is
 * PROCESSING, then stops polling once the status transitions to COMPLETED or
 * FAILED. Apollo's cache is shared with the main TransferOrderDetails query
 * (same query/variables), so the UI reflects poll results automatically.
 */
export function useAssetTransferPolling( {
	transferOrderId,
	assetTransferStatus,
}: UseAssetTransferPollingParams ) {
	const isProcessing = assetTransferStatus === AssetTransferStatus.Processing

	const { stopPolling } = useTransferOrderQuery( {
		variables: { transferOrderId },
		skip: !transferOrderId,
		fetchPolicy: 'cache-and-network',
		pollInterval: isProcessing ? POLL_INTERVAL_MS : 0,
	} )

	useEffect( () => {
		if ( assetTransferStatus && assetTransferStatus !== AssetTransferStatus.Processing ) {
			stopPolling()
		}
	}, [ assetTransferStatus, stopPolling ] )
}
